__turbopack_context__.v({
  "content": "SearchBar-module-scss-module__Jq22CW__content",
  "placeholder": "SearchBar-module-scss-module__Jq22CW__placeholder",
  "placeholder-text": "SearchBar-module-scss-module__Jq22CW__placeholder-text",
  "search-bar": "SearchBar-module-scss-module__Jq22CW__search-bar",
  "search-input-wrapper": "SearchBar-module-scss-module__Jq22CW__search-input-wrapper",
  "search-item": "SearchBar-module-scss-module__Jq22CW__search-item",
  "search-item-wrapper": "SearchBar-module-scss-module__Jq22CW__search-item-wrapper",
  "search-list": "SearchBar-module-scss-module__Jq22CW__search-list",
  "selected": "SearchBar-module-scss-module__Jq22CW__selected",
  "thumbnail": "SearchBar-module-scss-module__Jq22CW__thumbnail",
});
